import { Button, Dialog, IconButton, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import { useTheme } from '@emotion/react';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import pdfIcon from '../../assets/images/pdfIcon.png';
import { useTranslation } from 'react-i18next';

const FileViewer = ({ closeModal, file, open, disableDownload }) => {
  const theme = useTheme();
  const blackMain = theme.palette.primary.text;
  const secondary = theme.palette.primary.text;
  const white = '#fff';
  const url = file;
  const fileName = url.substring(url.lastIndexOf('/') + 1);

  const [disableImage, setDisableImage] = useState(false);

  const {t} = useTranslation()

  const sx = {
    '& .MuiDialog-container': {
      alignItems: 'center',
      WebkitAlignItems: 'center',
      WebkitBoxAlign: 'center',
    },
    '& .MuiPaper-root': {
      width: '736px',
      height: '600px',
      margin: '8px',
      padding: '0 16px 23px 16px',
      borderRadius: '4px',
      maxWidth: '736px',
      maxHeight: 'calc(100% - 20px)',
    },
  };
  const handleDownload = async () => {
    setDisableImage(true);
    try {
      const response = await fetch(file);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const name = file?.split('/').pop();
      link.download = `${name}`;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading image:', error);
    }
  };

  const handleFileOpener = () => {
    // if (file) {
    //   if (fileType === 'image') {
    //     setOpenModal(true);
    //   } else {
    //     const blob = new Blob([file], { type: file.type })
    //     const dataUrl = window.URL.createObjectURL(blob);
    //     window.open(dataUrl, '_blank', 'noreferrer')
    //   }
    // } else {
    //   const type = url.split('.').pop();
    //   if (type === 'jpg' || type === 'png' || type === 'jpeg' || type === 'webp') {
    //     setOpenModal(true);
    //   } else {
    //     window.open(url, '_blank', 'noreferrer')
    //   }
    // }

  }
  return (
    <div>
      <Dialog
        sx={sx}
        open={open}
        onClose={closeModal}
        className="AddUserContainer bottomDialog"
      >
        <Stack
          style={{
            borderBottom: '1px solid rgb(112,112,112,0.3)',
            paddingBottom: '10px',
            marginBottom: '16px',
            position: 'sticky',
            top: '0',
            paddingTop: '23px',
            zIndex: '99',
            background: '#FFF',
          }}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            style={{ color: blackMain }}
            className="fw-bold fs-14 ff-Roboto"
          >
           {t('View Document')} 
          </Typography>
          <div>
            <IconButton onClick={() => closeModal(false)}>
              <ClearIcon style={{ color: blackMain, transform: 'scale(1.143)' }} />
            </IconButton>
          </div>
        </Stack>
        <Stack
          direction="column"
          height="100vh"
        >
          {Boolean(file) && <Stack
            alignSelf="center"
            justifyContent="center"
            marginTop={'30px'}
          >
            {file?.split('.')?.pop() === 'pdf' ? (
              <img
                src={pdfIcon}
                alt={fileName}
                width={'300px'}
                height={'300px'}
              />
            ) : (
              <img
                src={file}
                alt={fileName}
              />
            )}
          </Stack>}

          {!disableDownload && (
            <Stack>
              <Button
                style={{ alignSelf: 'center', position: 'relative' }}
                sx={{
                  width: '160px',
                  height: '56px',
                  marginBottom: '40px',
                  marginTop: '40px',
                  color: white,
                  backgroundColor: secondary,
                  '&:hover': {
                    backgroundColor: secondary,
                    color: white,
                  },
                }}
                onClick={() => {
                  setDisableImage(true);
                  handleDownload();
                }}
                disabled={disableImage}
              >
                Download
                <SaveAltIcon sx={{ fontSize: '20px', marginLeft: '10px', marginBottom: '6px' }} />
              </Button>
            </Stack>
          )}
        </Stack>
      </Dialog>
    </div>
  );
};

export default FileViewer;
